/**
 * Auth Composable
 *
 * Provides authentication functionality using the auth store
 */
import { computed } from 'vue';
import { useAuthStore } from '@/stores';

export function useAuth() {
  const authStore = useAuthStore();

  const isAuthenticated = computed(() => authStore.isAuthenticated);
  const user = computed(() => authStore.user);
  const isLoading = computed(() => authStore.isLoading);

  /**
   * Full logout — calls backend API to revoke the refresh token,
   * clears all local tokens/state, then redirects to /login.
   *
   * Delegates to authStore.logout() so credential and SSO sessions
   * are both properly terminated (Cognito refresh token revoked).
   */
  async function logout() {
    await authStore.logout();
  }

  return {
    isAuthenticated,
    user,
    isLoading,
    logout,
  };
}
